import Axios, { AxiosPromise } from "axios";
import consts from "@/consts";
import { store } from "@/store"

const getExerciseHTML = (eid: Number): AxiosPromise => {
  return Axios({
    url: consts.serverURL + `my_exercise/${store.getters.UID}/${eid}`,
    headers: { Authentication: store.getters.JWT }
  });
};

const getSession = (sid: string): AxiosPromise => {
  return Axios({
    url: consts.serverURL + `session/${sid}/newresults`,
    headers: { Authentication: store.getters.JWT }
  });
};

const getSharedSession = (sid: string): AxiosPromise => {
  return Axios({
    url: consts.serverURL + `session/public/${sid}/newresults`,
    headers: { Authentication: store.getters.JWT }
  });
};

export { getExerciseHTML, getSession, getSharedSession };
